import EFPic from '@/components/UI/EFPic';
import EFVideoModal from '@/components/UI/EFVideoModal';
// import EFArrowRight from '@/components/UI/svg/CSR/Icons/EFArrowRight';
import EFYoutube from '@/components/UI/svg/CSR/Icons/EFYoutube';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';

export default function F() {
    const { useLang, useState, useRouter, useEffect } = useGlobal();
    const { locale } = useRouter()
    const { t } = useLang('csr');
    const data = [
        { video: 'https://www.youtube.com/embed/QVI6kyRm3zo', desc: t('secF_list1_desc'), img: ['/img/csr/h5/6_1.webp', '/img/csr/h5/6_1.jpg'] },
        { video: 'https://www.youtube.com/embed/fbHNSN33w8w', desc: t('secF_list2_desc'), img: ['/img/csr/h5/6_2.webp', '/img/csr/h5/6_2.jpg'] },
        { video: 'https://www.youtube.com/embed/oMAAlclPCRQ', desc: t('secF_list3_desc'), img: ['/img/csr/h5/6_3.webp', '/img/csr/h5/6_3.jpg'] },
    ];

    const goMore = () => {
        window.location.href = '/';
    };

    const [showYoutubeVideo, setShowYoutubeVideo] = useState(false)
    const [youtubeSource, setYutubeSource] = useState(data[0]?.video)

    const onYoutubeClick = (url: string) => {
        setShowYoutubeVideo(true)
        setYutubeSource(url)
    };

    let controller:any;
    useEffect(()=>{
        controller = new ScrollMagic.Controller()
    }, [])
    useEffect(()=>{
        // logo
        new ScrollMagic.Scene({
            triggerElement: '.csr_h5_F',
            triggerHook: 1,
            offset: 160,
            // duration: 200,
        })
            .setClassToggle('.csr_h5_F .innerBox', 'enter')
            .addTo(controller)
        
        // 标题
        // new ScrollMagic.Scene({
        //     triggerElement: '.csr_h5_F .titleBox',
        //     triggerHook: 1,
        //     offset: 200,
        //     // duration: 200,
        // })
        //     .setTween(TweenMax.staggerTo('.csr_h5_F .titleBox .letter_f', 0.5, { opacity: 1, top: 0, stagger: 0.1 }, 0.05))
        //     .addTo(controller)

        // youtube视频图片
        const youtubeImgEls = document.querySelectorAll('.csr_h5_F .youtubeLists .youtubeImg') as unknown as HTMLCollectionOf<HTMLDivElement>;
        for(let i = 0; i < youtubeImgEls.length; i++){
            new ScrollMagic.Scene({
                triggerElement: youtubeImgEls[i],
                triggerHook: 1,
                // offset: 200,
                duration: 220,
            })
                .setTween(TweenMax.fromTo(youtubeImgEls[i], 0.5, { transform: 'scale(1.1)' }, { transform: 'scale(1)' }))
                .addTo(controller)
        }
    }, [])
    
    const letters: [string] = t('secF_title').split('')

    return (
        <div className={`csr_h5_F ${css.csr_h5_F}`}>
            <div className="innerBox">
                <div className="logoBox">
                    <div className="logo">
                        <EFYoutube width="1.26rem" height="0.26rem" />
                    </div>
                </div>
                <div className="titleBox">
                    <div className="title">
                        {letters?.map((letter: string, k:number) => <span key={k} className={`letter_f letter_${k}`}>{letter}</span>)}
                    </div>
                </div>
                <div className="youtubeBox">
                    <ul className="youtubeLists">
                        {data?.map((list: any, k: number) => (
                            <li className="youtubeList" key={k}>
                                <div className="imgBox">
                                    <div className="youtubeImg" onClick={() => onYoutubeClick(list?.video)}>
                                        <EFPic src={list?.img} alt={list?.desc} aria-label={list?.desc} />
                                    </div>
                                </div>
                                <p className="desc">{list?.desc}</p>
                            </li>
                        ))}
                    </ul>
                </div>
                {/* <div className="more" onClick={goMore}>
                    <span className="moreText">{t('secF_more')}</span>
                    <span className="arrow">
                        <EFArrowRight width="0.22rem" height="0.13rem" />
                    </span>
                </div> */}
            </div>
            <EFVideoModal
                visible={showYoutubeVideo}
                source={youtubeSource}
                onClose={() => setShowYoutubeVideo(false)}
                playerType={'YouTube'}
            />
        </div>
    );
}
